var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sound",on:{"mouseover":_vm.onMouseOver,"mouseleave":_vm.onMouseLeave,"click":function($event){$event.preventDefault();_vm.onClick($event)}}},[_c('canvas',{ref:"canvas",attrs:{"width":"30","height":"30"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b3a5ab74","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/components/app-sound/template.html
// module id = null
// module chunks = 